import * as firebase from 'firebase';

firebase.initializeApp({
  apiKey: 'AIzaSyA_GkXJHDpHbQV1dSG3DHyskCAt7syo6As',
  authDomain: 'battleblender-demo.firebaseapp.com',
  databaseURL: 'https://battleblender-demo.firebaseio.com',
  projectId: 'battleblender-demo',
  storageBucket: 'battleblender-demo.appspot.com',
  messagingSenderId: '297271254897'
});

const db = firebase.firestore();

namespace storage {
  export function sync<T>(
    key: string,
    initData: T,
    isPreferred: (newData: T, data: T) => boolean,
    handler: (data: T) => void,
  ): (() => void) {
    let latest = initData;
    const lsKey = 'bb:' + key;

    function maybeUpdate(newData: T) {
      if (isPreferred(newData, latest)) {
        latest = newData;
        localStorage.setItem(lsKey, JSON.stringify(latest));
        handler(latest);
      }
    }

    function onStorageValue(value: string | null) {
      if (value === null || value === JSON.stringify(latest)) {
        return;
      }

      maybeUpdate(JSON.parse(value) as T);
    }

    if (localStorage.getItem(lsKey) === null) {
      localStorage.setItem(lsKey, JSON.stringify(latest));
    } else {
      onStorageValue(localStorage.getItem(lsKey));
    }

    const storageListener = (evt: StorageEvent) => {
      if (evt.key !== lsKey) {
        return;
      }

      onStorageValue(localStorage.getItem(lsKey));
    };

    window.addEventListener('storage', storageListener);

    const doc = db.collection('rooms').doc(key);

    const dbOff = doc.onSnapshot(roomData => {
      const snapData = roomData.data();

      if (snapData === undefined) {
        console.log('Sending room data to firebase');
        doc.set(latest).catch(console.error);
        return;
      }

      console.log('Got room data from firebase');
      maybeUpdate(snapData as any as T); // tslint:disable-line
    });

    return () => {
      window.removeEventListener('storage', storageListener);
      dbOff();
    };
  }

  export function set<T>(key: string, newData: T, isPreferred: (newData: T, data: T) => boolean) {
    const lsKey = 'bb:' + key;
    const localValue = localStorage.getItem(lsKey);

    if (localValue === null) {
      localStorage.setItem(lsKey, JSON.stringify(newData));
    } else {
      const localRoom = JSON.parse(localValue) as T;

      if (isPreferred(newData, localRoom)) {
        localStorage.setItem(lsKey, JSON.stringify(newData));
      } else {
        // localStorage had preferred value, don't send newData to firebase
        return;
      }
    }

    const doc = db.collection('rooms').doc(key);

    doc.get().then((snap) => {
      const snapData = snap.data();

      if (snapData === undefined || isPreferred(newData, snapData as any as T)) { // tslint:disable-line
        console.log('Sending room data to firebase');
        doc.set(newData).catch(console.error);
      }
    });
  }
}

export default storage;


// WEBPACK FOOTER //
// ./src/storage.tsx